import { goToCart } from '@/services/FramedCheckout/navigationServices'
import { getCustomer } from '@/services/FramedCheckout/customerServices'

import { getCart } from '@/services/FramedCheckout/orderServices/getCart'
import { getOrder } from '@/services/FramedCheckout/orderServices/getOrder'

import { createNonBopusConsignments, isOrderUpdatePending } from '@/services/FramedCheckout/shipmentServices'

import { getPaymentMethods } from '@/services/FramedCheckout/paymentServices'

import { log, error } from '@/services/Log'

import { isValidAddress } from '@/helpers'

import recreateOrder from '@/services/FramedCheckout/orderServices/recreateOrder'
import Facebook from '@/services/Facebook'

const initializeOrder = async ({ order }) => {
  let newOrder = { ...order }
  // TODO: DETECT CACHE FAILURE BY LOOKING AT SHIPMENT ADDRESSES AND AVAILABLE SHIPPING OPTIONS
  const shipmentFailedToProvideOptions = ({
    availableShippingOptions, shippingAddress,
  }) => !availableShippingOptions.length && !!isValidAddress(shippingAddress)

  const bigcommerceHasFailedShippingOptionsCache = (
    !!newOrder.shipments && !!newOrder.shipments.find(shipmentFailedToProvideOptions)
  )
  if (bigcommerceHasFailedShippingOptionsCache) {
    log('bigcommerce Has Failed Shipping Options Cache')
    const recoveredOrder = await recreateOrder({ order: newOrder })
    if (recoveredOrder.success && recoveredOrder.newOrder) {
      newOrder = recoveredOrder.newOrder
    }
  }

  const shouldSplitFurnitureShipment = !!newOrder.shipments.find(({ isBopus, lineItems }) => (
    !isBopus
    && !!lineItems.find(({ isFurniture }) => isFurniture)
    && !!lineItems.find(({ isFurniture }) => !isFurniture)
  ))
  const usedAddress = newOrder?.shipments?.find?.(({ isBopus }) => !isBopus)?.shippingAddress
  if (
    shouldSplitFurnitureShipment
    || isOrderUpdatePending({ order: newOrder, address: usedAddress ?? {} })
  ) {
    const response = await createNonBopusConsignments({
      order: newOrder, address: usedAddress ?? {},
    })
    newOrder = response.newOrder
    log('Split Furniture Shipment', { newOrder })
  }
  // Should check for multiple BOPUS shipments for the same store
  return newOrder
}

// eslint-disable-next-line import/prefer-default-export
export const initializeCheckout = async () => {
  log('initializeCheckout Start')
  let addresses
  let savedInstruments
  let order
  let cart
  let customer
  
  try {
    Facebook.init()
  } catch (err) {
    error(`Pixel Failed to initializeCheckout ${err}`)
  }

  try {
    try {
      cart = await getCart()
    } catch {
      throw new Error('Failed to get cart')
    }
    if (!cart) {
      await goToCart()
      return { success: false }
    }
    try {
      order = await initializeOrder({
        order: await getOrder({ cart }),
      })
    } catch {
      throw new Error('Failed to initializeOrder')
    }
    try {
      customer = await getCustomer({ customerId: cart.customerId })
    } catch (err) {
      error(`Failed to retrieve customer ${err}`)
    }
    if (customer) {
      addresses = customer?.addresses
      try {
        savedInstruments = await getPaymentMethods({ cartId: cart.id })
      } catch {
        error('Failed to retrieve savedInstruments')
      }
    }
    log('initializeCheckout End', {
      success: true, cart, order, customer, addresses, savedInstruments,
    })

    try {
      Facebook.initializeCheckout({
        user: { email: customer?.email || null, phone: customer?.phone || null },
        content_ids: cart.lineItems.map(({ sku }) => sku),
        contents: cart.lineItems.map(({ sku, quantity, salePrice }) => ({ id: sku, quantity, item_price: salePrice })),
        value: order.grandTotal,
        num_items: cart.lineItems.reduce((total, { quantity }) => total + quantity, 0),
      })
    } catch (err) {
      error(`Pixel Failed to initializeCheckout ${err}`)
    }

    return {
      success: true, cart, order, customer, addresses, savedInstruments,
    }
  } catch (err) {
    error(`initializeCheckout FAILED:\t ${err}`)
    return initializeCheckout()
  }
}
